import { useEffect } from "react";
import Lenis from "lenis";
import { motion, useScroll, useSpring } from "framer-motion";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import SmileGallery from "@/components/SmileGallery";
import Doctor from "@/components/Doctor";
import Reviews from "@/components/Reviews";
import BookingSection from "@/components/BookingSection";
import LocationSection from "@/components/LocationSection";
import Footer from "@/components/Footer";

function App() {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 28 });

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#070B12] font-sans text-ink">
      <motion.div
        style={{ scaleX: progress }}
        className="fixed inset-x-0 top-0 z-[60] h-[3px] origin-left bg-gradient-to-r from-toothcyan via-sky-400 to-ember shadow-[0_0_12px_rgba(23,210,245,0.5)]"
        data-testid="scroll-progress-bar"
      />
      <Toaster position="top-center" richColors theme="dark" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <SmileGallery />
        <Doctor />
        <Reviews />
        <BookingSection />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
